module.exports = __webpack_public_path__ + "static/media/frozen@3x.a3c47a16.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/frozen@3x.png
// module id = 666
// module chunks = 1